import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { UntypedFormGroup } from '@angular/forms';
import { UnitType } from '../../../../../models/enums/unit-type.enum';
import { MeasurementService } from '../../../../../services/measurement.service';

@Component({
    selector: 'app-reduced-area-bolting',
    templateUrl: './reduced-area-bolting.component.html',
    styleUrls: ['./reduced-area-bolting.component.scss'],
})
export class ReducedAreaBoltingComponent implements OnInit {
    @Input() form: UntypedFormGroup;
    @Input() cssClass;
    @Output() redAreaBoltLoad: EventEmitter<string> = new EventEmitter();

    tooltip_position = 'above';
    threadType: string;
    boltType: string;
    isEnable: boolean = false;

    constructor(private measSvc: MeasurementService) {}

    ngOnInit(): void {
        this.form.get('redAreaBolt').disable();
        this,
            this.form.get('isRedAreaBoltSelected').valueChanges.subscribe((res) => {
                if (res) {
                    this.isEnable = true;
                    this.form.get('redAreaBolt').enable();
                    this.form.get('redAreaBolt').setValue(this.measSvc.format('0', UnitType.DefaultLengthUnit));
                } else {
                    this.form.get('redAreaBolt').setValue(undefined);
                    this.form.get('redAreaBolt').disable();
                }
            });
        this.form.get('redAreaBolt').valueChanges.subscribe((value) => {
            if (value) {
                this.form.get('redAreaBolt').patchValue(this.measSvc.format(value, UnitType.DefaultLengthUnit), { emitEvent: false });
            }
        });
    }
}
